var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.member)?_c('li',{staticClass:"p-2"},[_c('div',{staticClass:"d-flex align-items-center justify-content-between"},[_c('div',{staticClass:"member__content"},[_c('p',{staticClass:"member__name mr-3"},[_vm._v(" "+_vm._s(_vm.member.name)+" ")])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }